import Devs from './components/Developers'
import Permissions from './components/Permissions'

const Developers: React.VFC = () => {
  return (
    <>
      <Devs />
      <Permissions />
    </>
  )
}

export default Developers
